export enum SystemType {
    EPR_RETAIL = "EPR_RETAIL",
    EPR_THIRD_PARTY = "EPR_THIRD_PARTY"
}